import { X } from 'lucide-react';
import { useFitnessStore } from '../../../store/fitnessStore';

export default function PlanModal() {
  const modal = useFitnessStore((s) => s.modal);
  const closeModal = useFitnessStore((s) => s.closeModal);
  if (modal?.type !== 'plan') return null;
  const plan = modal.data;
  if (!plan) return null;

  const weeks = plan.weeklyStructure || plan.weeks || [];

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100, display: 'flex', alignItems: 'flex-end', backdropFilter: 'blur(6px)' }}
      onClick={closeModal}
      role="presentation"
    >
      <div style={{ background: '#141416', borderRadius: '20px 20px 0 0', width: '100%', maxHeight: '88vh', overflowY: 'auto', padding: 20 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <div style={{ fontFamily: 'Bebas Neue', fontSize: 24 }}>{plan.planName || plan.blockName}</div>
          <button type="button" onClick={closeModal} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 8, padding: 8, cursor: 'pointer', color: '#fff' }}><X size={18} /></button>
        </div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginBottom: 16 }}>{plan.planDescription || plan.blockGoal}</div>

        {weeks.map((week, wi) => {
          const exercises = week.exercises || week.days?.flatMap((d) => d.exercises) || [];
          const label = week.dayName || `WEEK ${week.week || wi + 1}${week.theme ? ` — ${week.theme.toUpperCase()}` : ''}`;
          return (
            <div key={wi} style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#E8FF47', letterSpacing: 1, marginBottom: 10 }}>{label}</div>
              {exercises.map((ex, ei) => (
                <div key={ei} style={{ background: '#1C1C1F', borderRadius: 10, padding: '10px 14px', marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 2, textTransform: 'capitalize' }}>{ex.name}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
                      {ex.sets ? `${ex.sets} sets × ${ex.reps}` : ex.reps}
                      {ex.rest ? ` · Rest ${ex.rest}` : ''}
                    </div>
                  </div>
                  {ex.intensity && <div style={{ fontSize: 11, padding: '3px 8px', borderRadius: 20, background: 'rgba(232,255,71,0.1)', color: '#E8FF47' }}>{ex.intensity}</div>}
                </div>
              ))}
            </div>
          );
        })}

        {(plan.progressionNotes || plan.recoveryProtocol) && (
          <div style={{ background: 'rgba(232,255,71,0.06)', border: '1px solid rgba(232,255,71,0.15)', borderRadius: 12, padding: 14, marginTop: 8 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: '#E8FF47', letterSpacing: 1, marginBottom: 6 }}>NOTES</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>{plan.progressionNotes || plan.recoveryProtocol}</div>
          </div>
        )}
      </div>
    </div>
  );
}
